import * as THREE from "three";

export default class Bounds {
    constructor(width, height, depth, center = new THREE.Vector3()) {
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.center = center;

        this.min = new THREE.Vector3(
            center.x - width / 2,
            center.y - height / 2,
            center.z - depth / 2,
        );
        this.max = new THREE.Vector3(
            center.x + width / 2,
            center.y + height / 2,
            center.z + depth / 2,
        );

        // Optional debug-only visual; keep invisible in production
        this.mesh = new THREE.Mesh(
            new THREE.BoxGeometry(width, height, depth),
            new THREE.MeshBasicMaterial({
                color: 0xffffff,
                wireframe: true,
                visible: false,
            }),
        );
        this.mesh.position.copy(center);
    }
}
